export const resultsPerPage = 5

export const setFirstAndLastIndex = (isMobileMapOpen, activePageNum) => {
  if (isMobileMapOpen) return [0, 25]

  return [resultsPerPage * (activePageNum - 1), resultsPerPage * activePageNum]
}

export const clinicIndexToCardIndex = (clinicIndex) =>
  clinicIndex % resultsPerPage

export const clinicIndexToPageNum = (clinicIndex) =>
  Math.floor(clinicIndex / resultsPerPage) + 1

// Generates a link to a clinic's detail page, optionally including enough parameters to return to this search
export const generateClinicLink = (clinicId, locale, searchParams = {}) => {
  const searchParamsString =
    Object.keys(searchParams).length > 0
      ? `?${new URLSearchParams(searchParams)}`
      : ''
  const localeUrl = locale === 'es' ? '/es' : ''
  return `${localeUrl}/find-health-care/clinics/${clinicId}${searchParamsString}`
}

// Open a link, but simulate opening in a new tab if the user presses CMD / CTRL
export const openLink = (href, e) => {
  if (!e.ctrlKey && !e.metaKey) {
    window.location = href
  } else {
    window.open(href, '_blank').focus()
  }
}
